.container {
  display: flex;
  align-items: center;
  justify-content: center;
}

.wrapper {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.text {
  font-size: var(--font-size-lg);
  text-align: center;
}

.link {
  font-weight: bold;
}
